import { render, staticRenderFns } from "./FilterYears.vue?vue&type=template&id=63da1cab"
import script from "./FilterYears.vue?vue&type=script&lang=js"
export * from "./FilterYears.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports